const TemplateVehiclesEndPoints =  {
    GET_LIST_OF_SEAT_TEMPLATES: `/api/templateVehicle`,
}

export default TemplateVehiclesEndPoints